var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16578 0.234315C5.4782 0.546734 5.4782 1.05327 5.16578 1.36569L2.53147 4L5.16578 6.63432C5.4782 6.94673 5.4782 7.45327 5.16578 7.76569C4.85336 8.0781 4.34683 8.0781 4.03441 7.76569L0.834412 4.56569C0.521993 4.25327 0.521993 3.74673 0.834412 3.43431L4.03441 0.234315C4.34683 -0.0781049 4.85336 -0.0781049 5.16578 0.234315Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.49ca7ddc0b1303abdd1457a48da672d3.svg";
export { ForwardRef as ReactComponent };